import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ProfileIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 18 18" {...props} ref={ref}>
          <path
            d="M14.7645 14.5C13.6744 12.4189 11.502 11 9 11C6.49796 11 4.32556 12.4189 3.23551 14.5M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9ZM12 7.5C12 9.15685 10.6569 10.5 9 10.5C7.34315 10.5 6 9.15685 6 7.5C6 5.84315 7.34315 4.5 9 4.5C10.6569 4.5 12 5.84315 12 7.5Z"
            stroke="currentColor"
          />
        </svg>
      </Icon>
    );
  },
);

ProfileIcon.displayName = "ProfileIcon";
